import React from 'react'

import List from './list'
import Create from './form/create'
import Update from './form/update'
import Show from './show/show'
import Receivable from './receivable'
import ReceivableXTM from './receivableXtm'

import { Switch, Route, Redirect } from 'react-router-dom'
import {
  LAYOUT_MANAGER_JOB_LIST,
  LAYOUT_MANAGER_JOB_NEW,
  LAYOUT_MANAGER_JOB_EDIT,
  LAYOUT_MANAGER_JOB_SHOW,
  LAYOUT_MANAGER_TASK_RECEIVABLE_SALESFORCE,
  LAYOUT_MANAGER_TASK_RECEIVABLE_XTM
} from '../navigation'

const Connector = (props) => (
  <Switch>
    <Route path={LAYOUT_MANAGER_JOB_LIST} render={(routeProps) => <List {...props} {...routeProps} />} />

    <Route path={LAYOUT_MANAGER_JOB_NEW}>
      <Create />
    </Route> 
    <Route path={LAYOUT_MANAGER_JOB_EDIT(':id')}>
       <Update />
    </Route>
    <Route path={LAYOUT_MANAGER_JOB_SHOW(':id')}>
      <Show />
    </Route>
    <Route
      path={LAYOUT_MANAGER_TASK_RECEIVABLE_SALESFORCE(':id')}
      render={(routeProps) => <Receivable {...props} {...routeProps} />}
    />
    <Route
      path={LAYOUT_MANAGER_TASK_RECEIVABLE_XTM(':id')}
      render={(routeProps) => <ReceivableXTM {...props} {...routeProps} />}
    />

    <Redirect to={LAYOUT_MANAGER_JOB_LIST} />
  </Switch>
)

export default Connector
